import { useEffect, useState } from 'react';
import { api, ApiError } from '../lib/api';
import { saveGuest } from '../lib/guest';
import { navigate } from '../lib/router';
import { Mango } from '../ui/icons';

interface JoinResult {
  token: string;
  expiresIn: number;
  inviteUrl?: string;
  restaurant: { name: string };
  session: { id: string; tableName: string };
}

const MESSAGES: Record<string, [string, string]> = {
  no_session: ['รอพนักงานเปิดโต๊ะก่อนนะคะ', 'Please ask staff to open your table, then scan again.'],
  session_closed: ['โต๊ะนี้ปิดแล้ว', 'This table session has ended.'],
  qr_outdated: ['QR นี้ใช้ไม่ได้แล้ว', 'This QR code is no longer in use. Ask staff for the new one.'],
  invalid_code: ['QR ไม่ถูกต้อง', 'This QR code is not valid.'],
  ask_table: ['ขอรหัสจากเพื่อนที่โต๊ะ', 'Ask someone at your table to show their invite QR (My orders → Invite), or ask staff.'],
  slow_down: ['รอสักครู่', 'Please wait a moment and try again.'],
};

/** /j/<code>: the QR landing page. Joins the table session and moves on to the menu. */
export function Join({ code }: { code: string }) {
  const [error, setError] = useState<ApiError | null>(null);
  useEffect(() => {
    let cancelled = false;
    api<JoinResult>('POST', '/guest/join', { body: { code } })
      .then((r) => {
        if (cancelled) return;
        saveGuest({
          token: r.token,
          expiresAt: Date.now() + r.expiresIn * 1000 - 60_000,
          sessionId: r.session.id,
          tableName: r.session.tableName,
          restaurant: r.restaurant.name,
          inviteUrl: r.inviteUrl,
        });
        navigate('/t', true);
      })
      .catch((e: ApiError) => !cancelled && setError(e));
    return () => { cancelled = true; };
  }, [code]);

  const msg = error ? MESSAGES[error.code] ?? ['เกิดข้อผิดพลาด', error.message] : null;
  return (
    <main className="screen center">
      <div className="logo" style={{ width: 64, height: 64 }}><Mango /></div>
      {!msg ? (
        <>
          <div className="spinner" role="status" aria-label="Joining your table" />
          <p className="display" style={{ margin: 0, fontSize: 20 }}>กำลังเปิดเมนู… · Opening the menu…</p>
        </>
      ) : (
        <>
          <h1 className="display" style={{ margin: 0, fontSize: 24 }}>{msg[0]}</h1>
          <p className="muted" style={{ margin: 0 }}>{msg[1]}</p>
          {error?.code === 'no_session' || error?.code === 'offline' ? (
            <button className="cta light" style={{ maxWidth: 280 }} onClick={() => location.reload()}>ลองอีกครั้ง · Try again</button>
          ) : null}
        </>
      )}
    </main>
  );
}
